module.exports = __webpack_public_path__ + "files/a7d0da2d352081a2fbf9d93150da8214.png";